module.exports = __webpack_public_path__ + "static/media/pushstart.09ecb3d8.jpg";